import api from '@/api/api'

const state = {
  data: {},
  name: '',
}

const mutations = {
  GET_CHART: (state, data) => {
    state.data = data.data
    state.name = data.name
  },

  CLEAR_CHART: state => {
    state.data = {}
    state.name = ''
  },

  ADD_CODE: (state, code) => {
    // мутируем верхний уровень данных
    state.data = {
      ...state.data,
      codes: [...(state.data.codes || []), code],
    }
  },

  ADD_VARIABLE: (state, variable) => {
    // мутируем верхний уровень данных
    state.data = {
      ...state.data,
      variables: [...(state.data.variables || []), variable],
    }
  },

  EDIT_CODE: (state, data) => {
    const { codes, ...rest } = state.data

    const indexOfCode = codes.findIndex(
      el => el.internalId === data.code.internalId
    )

    if (data.target === 'series') {
      codes[indexOfCode].data.series.find(serie => {
        serie.values.map(value => {
          value.name === data.names.oldName
            ? (value.name = data.names.newName)
            : null
        })
      })
    } else if (data.target === 'self') {
      codes[indexOfCode] = data.code
    }

    state.data = {
      ...rest,
      codes: [...codes],
    }
  },

  EDIT_VARIABLE: (state, variable) => {
    const { variables, ...rest } = state.data

    const indexOfVariable = variables.findIndex(
      el => el.internalId === variable.internalId
    )
    variables[indexOfVariable] = variable

    // мутируем верхний уровень данных
    state.data = {
      ...rest,
      variables: [...variables],
    }
  },

  REMOVE_CODE: (state, name) => {
    const { codes } = state.data
    const newCodes = codes.filter(code => code.name !== name)

    // мутируем верхний уровень данных
    state.data = {
      ...state.data,
      codes: newCodes,
    }
  },

  REMOVE_VARIABLE: (state, name) => {
    const { variables, codes } = state.data
    const newVariable = variables.filter(variable => variable.name !== name)

    let newCodes = []

    if (codes && codes.length > 0) {
      newCodes = codes.filter(code => {
        return !code.data.series.find(serie => {
          return !serie.values.find(value => {
            return value.name !== name
          })
        })
      })
    }

    // мутируем верхний уровень данных
    state.data = {
      ...state.data,
      variables: newVariable,
      codes: newCodes,
    }
  },
}

const actions = {
  // eslint-disable-next-line
  deleteChart: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .deleteChart(id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },

  duplicateChart: ({ dispatch }, id) => {
    return new Promise((resolve, reject) => {
      api
        .getChart(id)
        .then(async response => {
          const postData = response.data
          delete postData.id

          if (postData.name.includes('(Копия от ')) {
            const name = postData.name
            postData.name = name.split('(Копия от')[0]
          }
          postData.name = `${
            postData.name
          } (Копия от ${new Date().toLocaleDateString('ru-RU')})`

          await dispatch('postChart', postData)
          resolve(response)
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },

  getChart: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .getChart(id)
        .then(response => {
          commit('GET_CHART', response.data)
          resolve(response)
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  },

  clearChart: ({ commit }) => {
    return new Promise(resolve => {
      commit('CLEAR_CHART')
      resolve()
    })
  },

  postChart: ({ rootState }, data) => {
    const postData = {
      ...data,
      date: new Date(),
      userId: rootState.user.id,
    }
    return new Promise((resolve, reject) => {
      api
        .postChart(postData)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  patchChart: ({ commit }, patchData) => {
    const { id, data } = patchData
    return new Promise((resolve, reject) => {
      api
        .patchChart(id, data)
        .then(response => {
          commit('GET_CHART', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  addCode: ({ commit }, data) => {
    commit('ADD_CODE', data)
  },

  addVariable: ({ commit }, data) => {
    commit('ADD_VARIABLE', data)
  },

  editCode: ({ commit }, data) => {
    commit('EDIT_CODE', data)
  },

  editVariable: ({ commit }, data) => {
    commit('EDIT_VARIABLE', data)
  },

  removeCode: ({ commit }, data) => {
    commit('REMOVE_CODE', data)
  },

  removeVariable: ({ commit }, data) => {
    commit('REMOVE_VARIABLE', data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
